import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import axios from 'axios';
import PayUForm from '../../Utils/PayUForm';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function NeaElectricity({ operatorCode }) {
  const currentUser = useSelector((state) => state.data);
  const [neaDetail, setNeaDetail] = useState(false);
  const [payuData, setPayuData] = useState(false);
  const [neaOfficeCode, setNEAOfficeCode] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { Subscriber, neaOfficeCode, ConsumerId, Mobile, amountWithCommission, wallet_type } = e.target;
    try {
      let sendData = {
        service: "nea",
        service_provider: operatorCode,
        msisdn: Subscriber.value,
        amount: amountWithCommission?.value,
        mobile: Mobile.value,
        office_code: neaOfficeCode.value,
        customer_id: ConsumerId?.value,
        //ExtraField3: neaDetail?.neaCharge,
        ref_stan: neaDetail && neaDetail['ref-stan'],
        bill_number: neaDetail && neaDetail['bill-number'],
        session_id: neaDetail && neaDetail['session-id'],
        wallet_type: wallet_type?.value,
        //payment_txn: txnid
      };
      if (neaDetail) {
        const response = await axios.post("/recharge/services/pay", sendData);
        const { status, message, hashData, rechage_response: rd } = response.data;
        if (status) {
          if (hashData) {
            const payuData = {
              hash: hashData.hash,
              txnid: hashData.txId,
              amount: hashData.amount,
              firstname: currentUser.name,
              email: currentUser.email,
            };
            setPayuData(payuData);
          }
          else {
            let rechrgeMessage = "<table align='center'><tr><td>Subscriber</td><td>" + rd.subscriber_number + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
            Swal.fire({
              title: 'Recharge Successful!',
              html: rechrgeMessage,
              icon: 'success',
              //confirmButtonText: 'OK'
            });
            setNeaDetail(false);
          }
        }
        else {
          toast(message);
        }
      }
      else {
        const response = await axios.post("/recharge/electricity/bill/query", sendData);
        const { status } = response.data;
        if (status) {
          setNeaDetail(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData = async () => {
    try {
      const response = await axios.post('/recharge/electricity/get/office/code', { service_provider: operatorCode });
      const { status, data } = response.data;
      if (status) {
        setNEAOfficeCode(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <>
            <div class="col-lg-4 col-md-4">
              <label>Subscriber Number</label>
              <input type="text" class="form-control" name="Subscriber" required />
            </div>
            <div class="col-lg-4 col-md-4">
              <label>NEA Ofice Code</label>
              <select class="form-control" name="neaOfficeCode">
                <option value="">--Select--</option>
                {
                  (neaOfficeCode && (neaOfficeCode).length > 0) && (neaOfficeCode).map((code) => (
                    <option value={code.office_code}>{code.title}</option>
                  ))
                }
              </select>
            </div>
            <div class="col-lg-4 col-md-4">
              <label>Consumer Id</label>
              <input type="text" class="form-control" name="ConsumerId" required />
            </div>
            <div class="col-lg-4 col-md-4">
              <label>Nepali Registered Mobile Number</label>
              <input type="text" class="form-control" name="Mobile" required />
            </div>
            {
              neaDetail && (
                <>
                  <div class="col-lg-4 col-md-4">
                    <label>Bill Amount</label>
                    <div>
                      <input type="text" class="form-control" name="amountWithCommission" value={(neaDetail['total-due-amount'])} />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Wallet Type</label>
                    <select class="form-control" name="wallet_type" required>
                      <option value="">--Select--</option>
                      <option value="wallet">Wallet</option>
                      <option value="remitance">Remitance</option>
                      <option value="payu">Online payment(Payu)</option>
                    </select>
                  </div>
                </>
              )
            }
            <div class="col-lg-12 col-md-12">
              <input type="submit" className="search-btn btn btn-primary" value={neaDetail ? "Pay" : "Check Payment"} />
            </div>
          </>
        </div>
      </Form>
    </>
  );
}

export default NeaElectricity;
